module.exports = __webpack_public_path__ + "static/media/dai.1a84a86b.svg";